module.exports = __webpack_public_path__ + "img/chess_japanchess06.7e90d55d.png";